<template>
    <v-progress-linear indeterminate v-if="loading"/>
    <v-app v-else>
        <v-toolbar app color="black" dark>
            <v-toolbar-title class="headline">
                <router-link :to="{name: 'Index'}" class="app-title">Radio Loland</router-link>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="logout" v-if="$route.name !== 'Login'">Logg ut</v-btn>
        </v-toolbar>

        <v-content>
            <div class="app-content-wrapper">
                <router-view/>
            </div>
        </v-content>
    </v-app>
</template>

<script>
    import axios from 'axios';
    import {jwtAuth} from "./helpers";

    export default {
        name: 'App',

        created() {
            this.loading = true;
            jwtAuth().then(isOk => {
                if (isOk) {
                    this.$router.push({name: 'Index'});
                }
            }).finally(() => {
                this.loading = false;
            });

            setInterval(() => {
                jwtAuth()
            }, 30000);

            axios.interceptors.response.use(function (response) {
                return response;
            }, function (error) {
                if (error.response.status === 401) {
                    this.$router.push({name: 'Login'});
                }
                return Promise.reject(error);
            });
        },
        data() {
            return {
                loading: false,
            }
        },
        methods: {
            logout() {
                localStorage.removeItem('refreshToken');
                location.reload();
            }
        }
    }
</script>

<style>
    .app-title {
        color: #fff;
        text-decoration: none;
    }

    .app-content-wrapper {
        margin: 0 auto;
        max-width: 940px;
    }
</style>
